var map = {
	"./Barcelona_1-0243.jpg": 69,
	"./Barcelona_1-DSC_0109.jpg": 70,
	"./Barcelona_1-DSC_0117.jpg": 71,
	"./Barcelona_1-DSC_0123.jpg": 72,
	"./Barcelona_1-DSC_0129.jpg": 73,
	"./Barcelona_1-DSC_0150.jpg": 74,
	"./Barcelona_1-DSC_0232.jpg": 75,
	"./Barcelona_1-DSC_0277.jpg": 76,
	"./China1.jpg": 77,
	"./China12.jpg": 78,
	"./China21.jpg": 79,
	"./China24.jpg": 80,
	"./China25-v2.jpg": 81,
	"./Coast10.jpg": 82,
	"./Coast12.jpg": 83,
	"./Coast4.jpg": 84,
	"./Image1-v2.jpg": 85,
	"./Image1.jpg": 86,
	"./Warriors3.jpg": 87,
	"./chinese-cyclists.jpg": 88,
	"./coast8.jpg": 89,
	"./cornwall1.jpg": 90,
	"./cornwall2.jpg": 91,
	"./cornwall3.jpg": 92,
	"./whitby.jpg": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;